import store from './store';

export const staysStore = store;
export * from './actions';
